import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  AccountApi,
  Configuration,
  ConfigurationsApi,
  SignupRequest,
} from "api";
import axios from "axios";
import { getBasePath } from "common/getConfiguration";
import { createErrorObject } from "errors/createErrorObject";
import { closeSnackbar, openSnackbar } from "features/ui";
import { getTranslationID } from "translation";
import { PostalCodeResponse } from "./types";

export const initialAsync = createAsyncThunk<
  { sitekey: string },
  void,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("signup/initialAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();
  const config = new Configuration({ basePath });
  try {
    const api = new ConfigurationsApi(config);
    const { data } = await api.getRecaptchaSiteKey();
    return { sitekey: data.siteKey };
  } catch (e) {
    const error = createErrorObject(e);
    if (error.errorCode === "E009999") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID("common.message.serverInternalError"),
        })
      );
    }
    return thunkApi.rejectWithValue({});
  }
});

export const postalCodeAsync = createAsyncThunk<
  PostalCodeResponse,
  { postalCode: string },
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("signup/postalCodeAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const url = "https://zipcloud.ibsnet.co.jp/api/search";

  const { postalCode } = args;

  const urlWithParam = `${url}?zipcode=${postalCode}`;

  try {
    // 郵便番号から住所を取得するAPI呼び出し
    const { data } = await axios.get(urlWithParam);
    return data;
  } catch (e) {
    return thunkApi.rejectWithValue({});
  }
});

export const signupAsync = createAsyncThunk<
  {
    /* Empty Object */
  },
  SignupRequest,
  {
    // rejectした時の返却値の型
    rejectValue: {
      /* Empty Object */
    };
  }
>("signup/signupAsync", async (args, thunkApi) => {
  // apiのConfigurationを取得する
  const basePath = getBasePath();

  const signupRequest = args;

  const config = new Configuration({ basePath });
  try {
    const accountApi = new AccountApi(config);
    const { data } = await accountApi.signup(signupRequest);

    thunkApi.dispatch(closeSnackbar());
    return data;
  } catch (e) {
    const err = createErrorObject(e);
    // reCAPTCHA NG
    if (err.errorCode === "E010501") {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID("common.message.serverInternalError"),
        })
      );
      return thunkApi.rejectWithValue({});
    }

    if (err?.statusCode === 409) {
      thunkApi.dispatch(
        openSnackbar({
          level: "error",
          message: getTranslationID("signupPage.message.usedEmailError"),
        })
      );
      return thunkApi.rejectWithValue({});
    }

    thunkApi.dispatch(
      openSnackbar({
        level: "error",
        message: getTranslationID("common.message.serverInternalError"),
      })
    );
    return thunkApi.rejectWithValue({});
  }
});
